export const ucOptions = {
  ADD_TO_MY_CART: 'ADD_TO_MY_CART',
  ADD_TO_MY_LIST: 'ADD_TO_MY_LIST',
  IMPORT_FROM_MY_LIST: 'IMPORT_FROM_MY_LIST'
};

export type UcItem = {
  item_id: string;
  price: string;
  quantity: number;
};